import { render, staticRenderFns } from "./CreateCertificate.vue?vue&type=template&id=34112d7b"
import script from "./CreateCertificate.vue?vue&type=script&lang=ts"
export * from "./CreateCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34112d7b')) {
      api.createRecord('34112d7b', component.options)
    } else {
      api.reload('34112d7b', component.options)
    }
    module.hot.accept("./CreateCertificate.vue?vue&type=template&id=34112d7b", function () {
      api.rerender('34112d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCertificate.vue"
export default component.exports